var $b5644a9daaf97251$exports = {};
$b5644a9daaf97251$exports = {
    "endTime": `Sluttidspunkt`,
    "startTime": `Starttidspunkt`,
    "time": `Klokkesl\xe6t`
};


export {$b5644a9daaf97251$exports as default};
//# sourceMappingURL=da-DK.module.js.map
